export const user = {
  add: { label: "Add user" },
  activity: "Activity",
  activityPlural: "Activities",
  lastLoginAt: "Last login",
  stateUpdatedAt: "Status updated at",
  role: "Role",
  rolePlural: "Roles",
  subject: "Subject",
  permission: "Permission",
  permissionPlural: "Permissions",
  removePermission: "Remove permission",
  otherPermissions: "Other permissions",
  organizationRole: {
    super: {
      label: "Super admin",
      description: "This user can manage any organization.",
    },
    admin: {
      label: "Admin",
      description: "This user can manage his organization.",
    },
    user: {
      label: "User",
      description:
        "This user can view his organization and manage all elements within it.",
    },
    noRole: {
      label: "No permission for {{organization}}",
      description:
        "This user will not be able to use the functionalities of the application.",
    },
  },
  delete: {
    label: "Delete user",
  },
  forceChangePassword: {
    info: "You are about to reset {{name}}'s password. This user will be disconnected and will have to change his password before being able to connect again.",
    button: "Reset password",
    error: "An error has occurred. Please try again later.",
    success: "Password reset successfully.",
  },
  form: {
    name: { label: "Name" },
    email: { label: "Email" },
    organization: { label: "Organization" },
    mainRole: { label: "Main role on this organization" },
    updatePassword: { label: "Change password" },
    oldPassword: { label: "Old password" },
    newPassword: { label: "New password" },
    newPasswordConfirmation: { label: "Password confirmation" },
    resetCode: { label: "Reset code" },
  },
  preferences: {
    changePassword: {
      title: "Step 2: change password",
      error:
        "An error has occurred. The password could not be changed. Please try again later.",
      success: "Your password has been successfully changed.",
    },
    notifications: {
      channels: {
        database: "Notification panel",
        broadcast: "Real-time notifications",
        mail: "Email",
      },
      groupsTitle: {
        generic: "General notifications",
        module: "Reports and modules",
        "transition-intervention": "State change of interventions",
        "transition-observation": "State change of observations",
      },
      updateSuccess: "Your preferences have been successfully updated.",
    },
    resetCode: {
      info: "A code will be sent to your email address so that you can complete the form in step 2 and change your password.",
      title: "Step 1: retrieve a reset code",
      success: "Reset code is sent. Please check your emails.",
    },
    tabs: {
      general: {
        label: "General",
      },
      notifications: {
        label: "Notifications",
      },
      password: {
        label: "Password",
      },
    },
  },
  resendInvite: {
    button: "Resend the invitation",
    error: "An error has occurred. Please try again later.",
    success: "Invitation sent successfully.",
  },
  resetMFA: {
    label: "Reset MFA",
    info: "You are about to reset the MFA for {{name}}. The user will receive an email with a temporary password to allow them to reset their account.",
  },
};
